import React from "react";
import { Button } from "react-bootstrap";
import { colorMaterial } from "../components/colorPaletteGroups";

const ORDER = ["PAL", "PFL", "MDF", "MUNKALAP", "GIZIR"];
const rank = (material) => {
  const index = ORDER.indexOf(material.toUpperCase());
  return index < 0 ? ORDER.length : index;
};
export function pickerMaterials(items, initialMaterial) {
  return [
    ...new Set([
      ...items.map(colorMaterial),
      ...(initialMaterial ? [initialMaterial] : [])
    ])
  ].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}
export default function PickerMaterial({ materials, value, onChange }) {
  return (
    <div
      className="d-flex gap-1"
      role="group"
      aria-label="Anyagtípus"
      data-picker-nav-group="material"
      style={{ maxWidth: "100%", overflowX: "auto", whiteSpace: "nowrap" }}
    >
      {materials.map((material) => (
        <Button
          key={material}
          size="sm"
          className="flex-shrink-0"
          data-picker-nav="material"
          variant={value === material ? "primary" : "outline-primary"}
          aria-pressed={value === material}
          onClick={(event) => {
            event.currentTarget.blur();
            onChange(material);
          }}
        >
          {material}
        </Button>
      ))}
    </div>
  );
}
